import { render } from "./UpcomingAppointmentsCard.vue?vue&type=template&id=7afedd1a&scoped=true"
import script from "./UpcomingAppointmentsCard.vue?vue&type=script&lang=js"
export * from "./UpcomingAppointmentsCard.vue?vue&type=script&lang=js"

import "./UpcomingAppointmentsCard.vue?vue&type=style&index=0&id=7afedd1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afedd1a"]])

export default __exports__